import styled from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE, RECORD_BAR_HEIGHT } from '../../fields.constants';

export const Bar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.zIndexes[3]};
  display: flex;
  align-items: center;
  gap: ${em(12)};
  height: ${em(RECORD_BAR_HEIGHT)};
  padding: 0 ${em(16)};
  font-size: ${rem(13.5)};
  color: ${PALETTE.ink};
  white-space: nowrap;
  background: ${PALETTE.lateTagBg};
  border-bottom: ${em(1)} solid ${PALETTE.lateBorder};

  b {
    flex: none;
    font-weight: 700;
  }
`;

export const Text = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BackButton = styled.button`
  flex: none;
  padding: 0;
  font-size: ${rem(13.5)};
  font-weight: 500;
  color: ${PALETTE.brandDark};
  text-decoration: underline;
  background: none;
  border: none;
  cursor: pointer;
`;
